/* eslint-disable import/prefer-default-export */
import axios from '../Axios'

const module = '/notifications-Sent'

export const getOneNotification = async (programId, key, step) => {
  const { data } = await axios.get(
    `${module}/get-one?programId=${programId}&key=${key}&step=${step}`
  )
  return data
}
